import React, {useEffect} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Breadcrumbs from "../../../../../../ui/Breadcrumbs";
import QueryTable from "../../../../../../ui/QueryTable";
import useQuery from "../../../../../../ui/QueryTable/useQuery";
import ModuleInfoDrawer from "../../components/ModuleInfoDrawer";

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Образовательные программы и модули",
    link: "/work/app/manage/resources/programs"
  },
  {
    label: "Мои модули",
    link: "#"
  },
];

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
});

const MyOpModuleList = () => {
  const [focusedModule, setFocusedModule] = React.useState(-1);
  const {root} = useStyles();
  const query = useQuery(2);

  useEffect(() => {
    query.load();
  }, []);

  const TableRowClick = (e) => {
    const focusedModule = e ? e.key : -1;
    setFocusedModule(focusedModule);
  };

  return (
    <div>
      <Breadcrumbs items={items}/>
      <div className={root}>
        <QueryTable focusedId={focusedModule}
                    onRowClick={TableRowClick}
                    {...query} />
        <ModuleInfoDrawer
          handleDrawerClose={() => TableRowClick(null)}
          moduleId={focusedModule}
          open={focusedModule !== -1}
        />
      </div>
    </div>
  );
};

export default MyOpModuleList;
